import React, { useState, useEffect } from "react";
import { API_WEB_URLS } from "../../constants/constAPI";
import { Fn_FillListData } from "../../store/Functions";
import RCDisplayPage from "../../common/RCDisplayPage";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const PageList_UserMaster = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // State Variables
  const [modal, setModal] = useState(false);
  const [selectedFormData, setSelectedFormData] = useState({});
  const [gridData, setGridData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [confirm_alert, setConfirmAlert] = useState(false);
  const [success_dlg, setSuccessDlg] = useState(false);
  const [dynamic_title, setDynamicTitle] = useState("");
  const [dynamic_description, setDynamicDescription] = useState("");
  const [SearchKeyArray, setSearchKeyArray] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchKey, setSearchKey] = useState("");

  // Get User Information from Local Storage
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const modalTitle = "User Details";
  const rtPage_Add = "/AddUser";
  const rtPage_Edit = "/EditUser";
  const API_URL = API_WEB_URLS.MASTER + "/0/token/User";

  // UseEffect to Fetch Grid Data on Component Load
  useEffect(() => {
    Fn_FillListData(dispatch, setGridData, "gridDataSearch", `${API_URL}/Id/0`, setSearchKey, setSearchKeyArray);
  }, [dispatch, API_URL]);

  // UseEffect to Update Filtered Data Whenever Grid Data Changes
  useEffect(() => {
    setFilteredData([...gridData]);
  }, [gridData]);

  // Handle Change of Search Key
  const handleSearchChange = (event) => {
    const searchValue = event.target.value.toLowerCase();
    const filteredData = gridData.filter((item) => {
      const searchKeyValue = item[searchKey]?.toLowerCase();
      return searchKeyValue?.includes(searchValue);
    });
    setFilteredData(filteredData);
    setCurrentPage(1); // Reset to First Page on Search
  };

  // Handle Search Key Selection
  const handleSearchKey = (item) => {
    setSearchKey(item);
  };

  // Handle Page Change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Handle Add Button Click
  const btnAdd_onClick = () => {
    navigate(rtPage_Add, { state: { Id: 0 } });
  };

  // Handle Edit Button Click
  const btnEdit_onClick = (e, formData) => {
    e.preventDefault();
    navigate(rtPage_Edit, { state: { Id: formData.Id } });
  };

  // Handle Delete Button Click (Optional: Connect to Delete Functionality)
  const btnDelete_onClick = (formData) => {
    // Implement delete functionality here if needed
  };

  // Render Grid Header for RCDisplayPage
  const renderGridHeader = () => (
    <tr>
      <th>Name</th>
    </tr>
  );

  // Render Grid Body for RCDisplayPage
  const renderGridBody = (formData) => (
    <tr key={formData.Id}>
      <td>{formData.Name}</td>
       
    </tr>
  );

  // Render Modal Body (if Needed)
  const renderModalBody = () => (
    <div>
      <p className="mb-4">Modal content goes here...</p>
      <p>data1</p>
    </div>
  );

  return (
    <div className="page-content">
      <RCDisplayPage
        SearchKeyArray={SearchKeyArray}
        currentPage={currentPage}
        searchKey={searchKey}
        Isbreadcrumb={true}
        breadCrumbTitle="User Master"
        breadcrumbItem="List"
        obj={obj}
        isSearchBox={true}
        isSNo={false}
        isCheckBox={false}
        isViewDetails={false}
        gridData={filteredData}
        gridHeader={renderGridHeader}
        gridBody={renderGridBody}
        handleSearchKey={handleSearchKey}
        handleSearchChange={handleSearchChange}
        handlePageChange={handlePageChange}
        btnAdd_onClick={btnAdd_onClick}
        btnEdit_onClick={btnEdit_onClick}
        btnDelete_onClick={btnDelete_onClick}
        confirm_alert={confirm_alert}
        success_dlg={success_dlg}
        dynamic_title={dynamic_title}
        dynamic_description={dynamic_description}
        isOpenModal={modal}
        modalTitle={modalTitle}
        selectedFormData={selectedFormData}
        modalBody={renderModalBody}
        isAdd={true}
        isEdit={obj?.UserType === "Admin"}
        isDelete={obj?.UserType === "Admin"}
        isPagination={true}
      />

       
    </div>
  );
};

export default PageList_UserMaster;
